import React from 'react';
import './companyCard.css'

function C2wCompanyCard( { obj=null } ) {
  return (
    <div className='C2wCompanyCard_ctn' style={{ backgroundColor : `${obj?.imgBg}`}}>
        <img src={`/assets/images/companies/${obj?.compName}`} alt={obj?.compName} />
    </div>
  )
}

export default C2wCompanyCard
